import { SignOnForm, MarketingDrawer } from '@app/components/general'
import { metaSetter } from '@app/utils'
import type { PageProps } from '@app/types'
// import Head from 'next/head'
// import { useRouter } from 'next/router'
import { MarketingShortTitle } from '@app/components/marketing'
import { AppLayout } from '@app/components/app-layout'
import loadNamespaces from 'next-translate/loadNamespaces'
import type { GetStaticProps } from 'next'
import { I18nDictionary } from 'next-translate'

export const getStaticProps: GetStaticProps<{
  __lang: string
  __namespaces?: Record<string, I18nDictionary>
}> = async (ctx) => {
  return {
    props: await loadNamespaces({
      ...ctx,
      pathname: '/register',
    }),
  }
}

function Register({ name }: PageProps) {
  return (
    <>
      <MarketingDrawer title={name} headerType={'h2'} emptyFooter authPage>
        <MarketingShortTitle hidden />
        <SignOnForm />
      </MarketingDrawer>
    </>
  )
}

Register.getLayout = AppLayout

export default metaSetter({ Register }, { gql: true, translation: 'register' })
